import React from "react";

export const GlobeIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#475467"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10" />
    <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" />
    <path d="M2 12h20" />
  </svg>
);

export const NgFlagIcon = () => (
  <span className="flex h-4 w-[18px] overflow-hidden rounded-[3px] border border-black/10 shadow-xs">
    <span className="h-full w-1/3 bg-[#008751]" />
    <span className="h-full w-1/3 bg-white" />
    <span className="h-full w-1/3 bg-[#008751]" />
  </span>
);

export const UsFlagIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    className="overflow-hidden rounded-full border border-black/10 shadow-xs"
  >
    <rect width="24" height="24" fill="#B22234" />
    <path
      d="M0 3.7h24v3.7H0zm0 7.4h24v3.7H0zm0 7.4h24v3.7H0z"
      fill="#FFFFFF"
    />
    <rect width="11" height="13" fill="#3C3B6E" />
    <circle cx="3" cy="3.5" r="0.8" fill="#FFFFFF" />
    <circle cx="8" cy="3.5" r="0.8" fill="#FFFFFF" />
    <circle cx="5.5" cy="6.5" r="0.8" fill="#FFFFFF" />
    <circle cx="3" cy="9.5" r="0.8" fill="#FFFFFF" />
    <circle cx="8" cy="9.5" r="0.8" fill="#FFFFFF" />
  </svg>
);

export const GbFlagIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    className="overflow-hidden rounded-full border border-black/10 shadow-xs"
  >
    <rect width="24" height="24" fill="#012169" />
    <path d="M0 0l24 24M24 0L0 24" stroke="#FFFFFF" strokeWidth="4" />
    <path d="M0 0l24 24M24 0L0 24" stroke="#C8102E" strokeWidth="2" />
    <path d="M12 0v24M0 12h24" stroke="#FFFFFF" strokeWidth="6" />
    <path d="M12 0v24M0 12h24" stroke="#C8102E" strokeWidth="3" />
  </svg>
);

export const EuFlagIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    className="overflow-hidden rounded-full border border-black/10 shadow-xs"
  >
    <rect width="24" height="24" fill="#003399" />
    <circle cx="12" cy="5" r="1.1" fill="#FFCC00" />
    <circle cx="17" cy="7" r="1.1" fill="#FFCC00" />
    <circle cx="19" cy="12" r="1.1" fill="#FFCC00" />
    <circle cx="17" cy="17" r="1.1" fill="#FFCC00" />
    <circle cx="12" cy="19" r="1.1" fill="#FFCC00" />
    <circle cx="7" cy="17" r="1.1" fill="#FFCC00" />
    <circle cx="5" cy="12" r="1.1" fill="#FFCC00" />
    <circle cx="7" cy="7" r="1.1" fill="#FFCC00" />
  </svg>
);

export const UsdcIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="11" fill="#2775CA" />
    <circle
      cx="12"
      cy="12"
      r="8.5"
      stroke="#FFFFFF"
      strokeWidth="1.2"
      strokeOpacity="0.4"
    />
    <text
      x="12"
      y="16.5"
      textAnchor="middle"
      fill="#FFFFFF"
      fontSize="13"
      fontWeight="bold"
      fontFamily="system-ui"
    >
      $
    </text>
  </svg>
);

export const UsdtIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="11" fill="#26A17B" />
    <path d="M7.5 8h9v2.2h-3.3v7h-2.4v-7H7.5V8z" fill="#FFFFFF" />
    <ellipse
      cx="12"
      cy="12.5"
      rx="5"
      ry="1.2"
      stroke="#FFFFFF"
      strokeWidth="1"
      fill="none"
      opacity="0.6"
    />
  </svg>
);

export const AllTypeIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#475467"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="2" y="5" width="20" height="14" rx="4" />
    <path d="M7 9.5h10M14 7l3 2.5-3 2.5" />
    <path d="M17 14.5H7M10 12l-3 2.5 3 2.5" />
  </svg>
);

export const WalletFundingIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#475467"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M6 9V7a6 6 0 0 1 12 0v2" />
    <rect x="3" y="9" width="18" height="13" rx="3" />
  </svg>
);

export const WalletConversionIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#475467"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10" />
    <path d="M16 8l-8 8M8 8h5M16 16h-5" />
  </svg>
);

export const SameCurrencyIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#475467"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="2" y="6" width="20" height="12" rx="3" />
    <circle cx="12" cy="12" r="3" />
    <path d="M6 12h.01M18 12h.01" />
  </svg>
);

export const CrossBorderIcon = GlobeIcon;

export const InvoicePaymentIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#475467"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M4 2v20l3-2 3 2 3-2 3 2 4-2V2z" />
    <path d="M8 7h8M8 11h8M8 15h5" />
  </svg>
);

export const FinancePaymentIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#475467"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="2" y="6" width="20" height="12" rx="3" />
    <ellipse cx="12" cy="12" rx="4" ry="2.5" />
  </svg>
);

export const OrderPaymentIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#475467"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 2L3 7v10l9 5 9-5V7l-9-5z" />
    <path d="M12 12L3 7M12 12l9-5M12 12v10" />
  </svg>
);

export const ShipmentPaymentIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#475467"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="1" y="5" width="13" height="10" rx="1.5" />
    <path d="M14 8h4.5l2.5 3.5v3.5h-7V8z" />
    <circle cx="5.5" cy="18" r="2" />
    <circle cx="17.5" cy="18" r="2" />
  </svg>
);
